import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ErpTrackingEndpoint } from '../constants/erp-tracking-endpoint';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { OPEN_INFO_API_URL } from '../../../../services/config';
import { RequestHeader } from '../../../constants';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { DeliveryNoteErpView, ErpTrackingPayload } from '../models/erp-tracking.model';

@Injectable({
  providedIn: 'root',
})
export class ErpTrackingItemService {
  constructor(private http: WrapperHttpService) {}

  getItem(payload: ErpTrackingPayload): Observable<DeliveryNoteErpView> {
    const url = `${OPEN_INFO_API_URL}${ErpTrackingEndpoint.Base}`;

    let params = new HttpParams();
    for (const property in payload) {
      if (payload.hasOwnProperty(property)) {
        params = params.append(property, payload[property]);
      }
    }

    return this.http.withLoading().get<DeliveryNoteErpView>(url, {
      params,
      headers: new HttpHeaders({
        [RequestHeader.SkipInterceptor]: '',
      }),
    });
  }
}
